import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { EventDTO } from 'src/app/api/models';
import { Floor } from 'src/app/api/models/showcases-dto';
import { PutTrayPayload, TrayDTO } from 'src/app/api/models/trays-dto';
import { LookupService } from 'src/app/api/services';
import { TraysService } from 'src/app/api/services/trays.service';
import { RoleEnum } from 'src/app/enums/role-enum';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-tray-form',
  templateUrl: './tray-form.component.html',
  styleUrls: ['./tray-form.component.scss']
})
export class TrayFormComponent implements OnInit {

  @Output() closeSidenav: EventEmitter<any> = new EventEmitter();

  @Input() tray?: TrayDTO;
  @Input() cloning?: boolean;
  @Input() isExtraTray!: boolean;

  readonly MAX: number = 256;

  trayForm: FormGroup = new FormGroup({});
  showTray: boolean = false;
  loading: boolean = false;
  floors: Floor[] = [];
  event?: EventDTO;

  get isEditMode(): boolean {
    return !this.cloning && !!this.tray;
  }

  constructor(
    public translateService: TranslateService,
    public traysService: TraysService,
    public lookupService: LookupService,
    public sharedService: SharedService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.event = this.sharedService.event;
    this.buildForm();
    setTimeout(() => this.showTray = true, 200)
  }

  //Costruzione del form
  buildForm() {
    let code = "";
    let referenceDate = null;
    if ((this.cloning || this.isEditMode) && this.tray) {
      code = this.tray.code;
      if (this.isExtraTray) {
        referenceDate = moment(this.tray.referenceDate).format('YYYY-MM-DD');
      }
    }
    this.trayForm = this.fb.group({
      code: new FormControl(code, [Validators.required, Validators.maxLength(this.MAX)]),
    });
    if (!this.isExtraTray) {
      this.trayForm.addControl('description', new FormControl(this.tray?.description));
    }
    if (this.isExtraTray) {
      this.trayForm.addControl('referenceDate', new FormControl(referenceDate, [Validators.required]));
      this.trayForm.addControl('location', new FormControl(this.tray?.location || ""));
    }
    if (this.isReadOnlyView()) {
      this.trayForm.disable()
    }
  }

  //Effettuo la creazione dello tray
  createTray() {
    this.trayForm.markAllAsTouched();
    if (this.event && this.trayForm.valid) {
      this.loading = true;
      this.traysService.createTray(this.event.id, this.trayForm.value, this.isExtraTray).subscribe(
        (res) => {
          if (this.cloning && this.isExtraTray) {
            this.addProductsToClonedTray(res)
          } else {
            this.closeDialog(true);
            this.loading = false;
            this.sharedService.openSnackBar(this.translateService.instant('PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.NOTIFICATION.SUCCESS'), false);
          }
        },
        (err) => {
          this.sharedService.openSnackBar(this.getErrorMessage(err), true);
          this.loading = false;
        })
    }
  }

  addProductsToClonedTray(idTray: any) {
    if (this.event && this.tray) {
      const sapCodes = this.tray?.products?.map(p => p.sapCode) || [];
      this.traysService.moveProductsInTray(this.event.id, idTray, sapCodes, true).subscribe(
        (res) => {
          this.closeDialog(true);
          this.loading = false;
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.NOTIFICATION.CLONED'), false);
        },
        (err) => {
          this.loading = false;
          this.sharedService.openSnackBar(this.getErrorMessage(err), true);
        },
      )

    }


  }

  //Effettuo la creazione dello tray
  updateTray() {
    if (this.isDisabledSave()) {
      return;
    }
    this.trayForm.markAllAsTouched();
    if (this.event && this.trayForm.valid && this.tray) {
      this.loading = true;
      let body: PutTrayPayload = {
        idHero: this.event.id,
        code: this.trayForm.controls['code'].value,
        id: this.tray.id
      }
      if (this.isExtraTray) {
        body.referenceDate = this.trayForm.controls['referenceDate'].value;
        body.location = this.trayForm.controls['location'].value;
      } else {
        body.description = this.trayForm.controls['description'].value;
      }
      this.traysService.updateTray(body, this.isExtraTray).subscribe(
        (res) => {
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.NOTIFICATION.SUCCESS'), false);
          this.closeDialog(true);
          this.loading = false;
        },
        (err) => {
          this.sharedService.openSnackBar(this.getErrorMessage(err), true);
          this.loading = false;
        })
    }
  }

  cancel() {
    if (this.tray) {
      this.traysService.deleteTray(this.tray?.id, this.isExtraTray).subscribe(
        (res) => {
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.NOTIFICATION.DELETE_SUCCESS'), false);
          this.closeDialog(true);
          this.loading = false;
        },
        (err) => {
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.NOTIFICATION.DELETE_ERROR'), true);
          this.loading = false;
        })
    }
  }

  closeDialog(isShowcaseCreated?: boolean): void {
    this.showTray = false;
    setTimeout(() => {
      this.closeSidenav.emit(isShowcaseCreated)
    }, 200)
  }

  isDisabledSave() {
    if (this.tray) {
      let isSameCode = this.trayForm.controls['code'].value === this.tray.code;
      if (this.isExtraTray) {
        return this.trayForm.pristine;
        // let isSameDate = false;
        // let referenceDate = this.trayForm.controls['referenceDate'].value;
        // let oldReferentDate = moment(this.tray.referenceDate).format('YYYY-MM-DD');
        // if (referenceDate && typeof referenceDate !== 'string') {
        //   referenceDate = referenceDate.format('YYYY-MM-DD')
        // }
        // isSameDate = referenceDate === oldReferentDate;
        // let isSameLocation = this.trayForm.controls['location'].value === this.tray.location;
        // return isSameCode && isSameDate && isSameLocation;
      } else {
        return isSameCode && this.trayForm.controls['description'].value === this.tray.description;
      }
    }
    return true;
  }

  getErrorMessage(err: any) {
    let message = this.translateService.instant('PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.NOTIFICATION.ERROR');
    if (err && err.error && Array.isArray(err.error.errors)) {
      let error = err.error.errors[0];
      if (error) {
        message = error.message
      }
    }
    return message;
  }

  isReadOnlyView() {
    return this.sharedService.isUserRole(RoleEnum.LOGISTIC_READONLY)
  }

  clearDate() {
    this.trayForm.controls['referenceDate'].setValue(null)
  }
}
